import { Link } from "components/shared/Link";
import cn from "classnames";
import styles from "./Breadcrumbs.module.scss";
import { SpriteIcon } from "components/UI/SpriteIcon";
import arrowRightIcon from "/public/img/icons/arrow-right.svg";
import { useAppSelector } from "@/store";
import { isWritingServiceSelector } from "@/store/global/globalSlice";
import { baseUrl, localUrl, WRITING_SERVICE_SUBDOMAIN } from "@/const";

export type BreadcrumbsProps = {
  className?: string;
  list: {
    position: number;
    name: string;
    href: string;
  }[];
};

export const Breadcrumbs = ({ list, className }: BreadcrumbsProps) => {
  return (
    <ul className={cn(styles.list, className)}>
      {list.map(({ position, name, href }, index) => (
        <li key={position} className={styles.item}>
          {index === list.length - 1 ? (
            <span dangerouslySetInnerHTML={{ __html: name }} />
          ) : (
            <Link href={href} includeSubdomain dangerouslySetInnerHTML={{ __html: name }} />
          )}
          {index < list.length - 1 && <SpriteIcon icon={arrowRightIcon} className={styles.icon} />}
        </li>
      ))}
    </ul>
  );
};
